import { useSyncExternalStore } from 'react'
import { compareSemver } from '@/lib/semver'
import { StorageKey } from '@/lib/storage'

const listeners = new Set<() => void>()

export function readWhatsNewLastSeenVersion(): string | null {
  const version = window.localStorage.getItem(StorageKey.WhatsNewLastSeenVersion)
  if (version !== null) compareSemver(version, version)
  return version
}

function subscribe(listener: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === StorageKey.WhatsNewLastSeenVersion) listener()
  }
  listeners.add(listener)
  window.addEventListener('storage', onStorage)
  return () => {
    listeners.delete(listener)
    window.removeEventListener('storage', onStorage)
  }
}

export function useWhatsNewLastSeenVersion(): string | null {
  return useSyncExternalStore(subscribe, readWhatsNewLastSeenVersion, () => __APP_VERSION__)
}

export function markWhatsNewSeen(version: string = __APP_VERSION__): void {
  compareSemver(version, version)
  if (readWhatsNewLastSeenVersion() === version) return
  window.localStorage.setItem(StorageKey.WhatsNewLastSeenVersion, version)
  listeners.forEach((listener) => listener())
}
